import legend from 'chartist-plugin-legend';
import ctAxisTitle from 'chartist-plugin-axistitle';
import tooltips from '../chartist/chartist-plugin-tooltips-patched';

export default function (xTitle, yTitle) {
  return {
    showPoint: true,
    lineSmooth: true,
    axisX: {
      showGrid: true,
      showLabel: true,
      offset: 60,
      labelInterpolationFnc(value) {
        return `${value}`;
      },
    },
    axisY: {
      onlyInteger: true,
      offset: 60,
      labelInterpolationFnc(value) {
        return `${value}`;
      },
    },
    plugins: [
      legend(),
      ctAxisTitle({
        axisX: {
          axisTitle: xTitle,
          axisClass: 'ct-axis-title',
          offset: {
            x: 0,
            y: 40,
          },
          textAnchor: 'middle',
        },
        axisY: {
          axisTitle: yTitle,
          axisClass: 'ct-axis-title',
          offset: {
            x: 0,
            y: -20,
          },
          flipTitle: false,
        },
      }),
      tooltips(),
    ],
  };
}



// WEBPACK FOOTER //
// ./src/chartist/chartist-options.js